import Vue from 'vue'
import Router from 'vue-router'

import utils from '@/globals'
import modules from '@/app/router'
import clientareamodules from '@/app/clientarea-app/router'
import state from '@/app/state'
import auth from '@/app/authorization/router'

Vue.use(Router)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    name: 'home',
    path: '/',
    meta: {
      resource: 'Home'
    },
    component: () => import('@/app/layout/Layout'),
    children: [
      ...modules,
      ...clientareamodules
    ]
  },
  ...auth
  ]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  utils().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  if (from.path.startsWith('/clientarea') || to.path.startsWith('/clientarea')) {
    document.body.classList.add('app-loading')
    setTimeout(() => next(), 10)
    return
  }

  if (from.path !== to.path && to.path !== '/login') {
    if (to.meta.requiredAuth === false) {
      return next()
    }

    let authenticate = state.getters['auth/authStatus'] !== 'error' || state.getters['auth/isAuthenticated']
    if (!authenticate) {
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }

    let authorize = true

    if (authorize) {
      if (to && (to.name === 'board' || to.name === 'viewcard')) {
        state.dispatch('board/openBoard', to.params.boardId)
      } else {
        state.dispatch('board/closeBoard')
      }
    } else {
      return next('/')
    }
  }

  document.body.classList.add('app-loading')
  setTimeout(() => next(), 10)
})

export default router
